import Animal from "./../asset/img/indiba_animal.jpeg";
import DeepBeauty from "./../asset/img/indiba_deep_beauty.jpeg";
import DeepCare from "./../asset/img/indiba_deepcare.jpeg";

export const BaseUrl = "http://39.97.178.20:5000";
export const fileUrl = "http://39.97.178.20";

/** 默认轮播图 */
export const swiperDefault = [Animal, DeepBeauty, DeepCare];

export const gradeMap: any = {
  "0": "",
  "1": "一级",
  "2": "二级",
  "3": "三级",
  "4": "四级",
};

export const gradeEnMap: any = {
  "0": "",
  "1": "Grade one of",
  "2": "Grade two of",
  "3": "Grade three of",
  "4": "Grade four of",
};

export const operatorMap: any = {
  0: "美容培训师",
  1: "运动医学培训师",
  2: "美容操作师",
  3: "运动医学操作师",
  999: "公司成员",
};

export const operatorMapEn: any = {
  0: "Beauty trainer",
  1: "Sports medicine trainer",
  2: "Beauty operator",
  3: "Sports medicine operator",
  999: "Company stuff",
};

export const privacyPolicy = `
我们重视用户的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。

您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。

如对本《隐私政策》或相关事宜有任何问题，请通过xxp564357196@163.com与我们联系。

我们可能收集的信息

我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。

您提供的信息

您在使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件或银行卡号等；

您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。

其他方分享的您的信息

其他方使用我们的服务时所提供有关您的共享信息。

我们获取的您的信息

您使用服务时我们可能收集如下信息：

日志信息，指您使用我们的服务时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括：

设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；

在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；

有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；

位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：

您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；

您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息；

您可以通过关闭定位功能，停止对您的地理位置信息的收集。

我们可能如何使用信息

我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：

向您提供服务；

在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；

帮助我们设计新服务，改善我们现有服务；

使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；

向您提供与您更加相关的广告以替代普遍投放的广告；

评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；

软件认证或管理软件升级；

让您参与有关我们产品和服务的调查。

为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。

您如何访问和控制自己的个人信息

我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。

我们可能分享的信息

除以下情形外，未经您同意，我们不会与任何第三方分享您的个人信息：

我们可能将您的个人信息与第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：

向您提供我们的服务；

实现“我们可能如何使用信息”部分所述目的；

履行我们在本《隐私政策》中的义务和行使我们的权利；

理解、维护和改善我们的服务。

如我们与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。

随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。

我们还可能为以下需要而保留、保存或披露您的个人信息：

遵守适用的法律法规；

遵守法院命令或其他法律程序的规定；

遵守相关政府机关的要求；

为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们、其他用户的人身和财产安全或合法权益所合理必需的用途。

信息安全

我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。 我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。

您分享的信息

我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。特别是，我们的社交媒体服务，是专为使您与世界各地的用户共享信息而设计，您可以使共享信息实时、广泛地传递。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。

因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该等特别服务条款提供的方式操作。

您分享的敏感个人信息

某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。

请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。

您同意按本《隐私政策》所述的目的和方式来处理您的敏感个人信息。

我们可能如何收集信息

我们或我们的第三方合作伙伴，可能通过cookies和web beacon收集和使用您的信息，并将该等信息储存为日志信息。

我们使用自己的cookies和web beacon，目的是为您提供更个性化的用户体验和服务，并用于以下用途：

记住您的身份。例如：cookies和web beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息；

分析您使用我们服务的情况。例如，我们可利用cookies和web beacon来了解您使用我们的服务进行什么活动，或哪些网页或服务最受您的欢迎；

广告优化。Cookies和web beacon有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。

我们为上述目的使用cookies和web beacon的同时，可能将通过cookies和web beacon收集的非个人身份信息，经统计加工后提供给广告商或其他合作伙伴，用于分析用户如何使用我们的服务，并用于广告服务。

我们的产品和服务上可能会有广告商或其他合作方放置的cookies和web beacon。这些cookies和web beacon可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies和web beacon收集和使用该等信息，不受本《隐私政策》约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookies或web beacon承担责任。

您可以通过浏览器设置拒绝或管理cookies或web beacon。但请注意，如果停用cookies或web beacon，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。同时，您还会收到同样数量的广告，但这些广告与您的相关性会降低。

广告服务

我们可能使用您的相关信息，向您提供与您更加相关的广告。

我们也可能使用您的信息，通过我们的服务、电子邮件或其他方式向您发送营销信息，提供或推广我们或第三方的如下商品和服务：

我们的服务，我们的关联公司和合作伙伴的商品或服务，包括即时通讯服务、网上媒体服务、互动娱乐服务、社交网络服务、付款服务、互联网搜索服务、位置和地图服务、应用软件和服务、数据管理软件和服务、网上广告服务、互联网金融，以及其他社交媒体、娱乐、电子商务、资讯和通讯软件或服务（统称“互联网服务”）；

第三方互联网服务供应商，以及与下列有关的第三方商品或服务：食物和餐饮、体育、音乐、电影、电视、现场表演及其他艺术和娱乐、书册、杂志和其他刊物、服装和配饰、珠宝、化妆品、个人健康和卫生、电子、收藏品、家用器皿、电器、家居装饰和摆设、宠物、汽车、酒店、交通和旅游、银行、保险及其他金融服务、会员积分和奖励计划，以及我们认为可能与您相关的其他商品或服务。

如您不希望我们将您的个人信息用作前述广告用途，您可以通过我们在广告中提供的相关提示，或在特定服务中提供的指引，要求我们停止为上述用途使用您的个人信息。

我们可能向您发送的邮件和信息

邮件和信息推送

您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。

与服务有关的公告

我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。

隐私政策的适用例外

我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：

您利用 “分享”键将某些内容分享到我们的服务，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的电脑装置cookies，从而正常运行上述功能；

我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站。

该等第三方社交媒体或其他服务可能由相关的第三方或我们运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非《通用服务条款》或本《隐私政策》）约束，您需要仔细阅读其条款。本《隐私政策》仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。

未成年人使用我们的服务

我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本《隐私政策》，并建议未成年人在提交的个人信息之前寻求父母或监护人的同意和指导。

隐私政策的适用范围

除某些特定服务外，我们所有的服务均适用本《隐私政策》。这些特定服务将适用特定的隐私政策。针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。该特定服务的隐私政策构成本《隐私政策》的一部分。如相关特定服务的隐私政策与本《隐私政策》有不一致之处，适用该特定服务的隐私政策。

请您注意，本《隐私政策》不适用于以下情况：

通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息；

通过在我们服务中进行广告服务的其他公司或机构所收集的信息。

变更

我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。
`;

/** 使用协议 */
export const protocol = `
用户在使用本手机软件的服务之前，应当仔细阅读本协议，并同意遵守本协议所有条款后方可成为本手机软件用户，一旦用户注册成功，则用户与本手机软件之间自动形成协议关系，用户应当受本协议的约束。用户在使用特殊的服务或产品时，应当同意接受相关协议后方能使用。未同意本协议内容的用户，仅能使用浏览功能。
一、使用规则
1.1.用户注册成功后，将产生用户名和密码等账户信息，用户应谨慎合理的保存、使用其用户名和密码。用户利用该账号和密码所进行的一切活动引起的任何损失或损害，由用户自行承担责任。如用户发现账号遭到未授权的使用或发生其他安全问题，应立即修改账号密码并妥善保管。
1.2.用户充分了解并同意，用户须对在手机软件上的注册信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人；不得利用他人的名义传播任何信息；不得恶意使用注册账号导致其他用户误认；否则本手机软件有权立即停止提供服务，收回账号并由用户独自承担由此而产生的一切法律责任。
1.3.用户不得利用本手机软件上载、复制、传播、发送如下内容，包括但不限于：
(1)反对宪法所确定的基本原则的；
(2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
(3)损害国家荣誉和利益的；
(4)煽动民族仇恨、民族歧视，破坏民族团结的；
(5)破坏国家宗教政策，宣扬邪教和封建迷信的；
(6)散布谣言，扰乱社会秩序，破坏社会稳定的；
(7)散布淫秽、色情、性暗示性挑逗、赌博、暴力、凶杀、恐怖或者教峻犯罪的；
(8)侮辱或者诽谤他人，或者侵害他人隐私权、名誉权、肖像权、知识产权、商业秘密等合法权利；
(9)含有法律、行政法规禁止的其他内容的信息；
(10)从事其他违反政策及公序良俗、社会公德的行为。
1.4.本手机软件运营方有权删除用户发表的属于上述情况的信息内容而无须通知用户；并且，用户一旦发表上述言论或信息，运营方有权将用户列为黑名单，禁止用户在本手机软件发言，并不需要取得用户本人的同意。用户有权向运营方举报其他用户的不当言论与不良内容。
1.5.用户须对在本手机软件上所传送信息的真实性、合法性、有效性、无害性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与本手机软件无关。
1.6本手机软件运营方有权判断用户评论、投稿是否符合本软件社区氛围，对于不符合社区氛围的言论，运营方有权删除而无需用户同意。
1.7用户对运营方的处置有不同意见，可以通过意见反馈的方式申诉。
1.8用户可以选择将本软件的评论，投稿同步到其他社交平台，例如微博、微信、QQ空间、人人网、豆瓣等。用户有权分享其他用户的评论、投稿到其他社交平台，而无需获得评论、投稿人的同意。通过本手机软手机软件公开发布的信息，用户间或用户与第三方有任何争议或纠纷，本手机软件对此不承担任何责任。
1.9本手机软件提供的服务中可能包括广告，用户同意在使用过程中显示本手机软件和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责，对用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，本手机软件不承担任何责任。
1.10用户在本手机软件内经营网络商店，必须另行同意《商家合作协议》内容，并受其约束。

二、责任声明
2.1用户明确同意其使用本手机服务所存在的风险及一切后果将完全由用户本人承担，本手机软件对此不承担任何责任。
2.2本手机软件无法保证网络服务一定能满足用户的要求，也不保证网络服务的及时性、安全性、准确性。
2.3对于因不可抗力或本软件不能控制的原因造成的网络服务中断或其它缺陷，本手机软件不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。
2.4基于以下原因而造成的利润、商业信誉、资料损失或其他有形或无形损失，本手机软件不承担任何直接、间接、附带、衍生或惩罚性的赔偿：
(1)本手机软件使用或无法使用；
(2)经由本手机软件购买或取得的任何产品、资料或服务；
(3)用户资料遭到未授权的使用或修改；
(4)其他与本手机软件相关的事宜。
2.5在使用本手机软件过程中存在来自任何他人的包括不实的、误导性的、欺骗性的、威胁性的、诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该等信息的行为，因此导致的用户或第三方的任何损失，本手机软件不承担任何责任。
2.6用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户同意赔偿本手机软件与合作公司、关联公司，并使之免受损害。

三、附则
3.1本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。
3.2本协议解释权及修订权归英特波科技（深圳）有限公司所有。
`;
